import React, { useState, useEffect } from 'react';
import { Form, Button, Col, Image, FormControl, Row, Table } from 'react-bootstrap';
import { ArrowRight, Plus, Trash2 } from 'lucide-react';
import NumberFormat from 'react-number-format';
import Phone from "../../Shared/common/components/Shared_FormControls/PhoneNumberField/PhoneNumberField";
import Email from "../../Shared/common/components/Shared_FormControls/Email/Email";
import TextBox from "../../Shared/common/components/Shared_FormControls/TextBox/TextBox";
import addIcon from '../../../assets/images/Icons/add-icon-gray.svg'
import deleteIcon from '../../../assets/images/Icons/deleteIcon.svg'

const DealershipInfoS3 = (props) => {

    const [validated, setValidated] = useState(false);
    const [currentFloorPlanCompaniesUsed, setCurrentFloorPlanCompaniesUsed] = useState('');
    const [currentRetailFinanceUsed, setCurrentRetailFinanceUsed] = useState('');
    const [productCompaniesUsed, setProductCompaniesUsed] = useState('');

    const [phoneValid, setPhoneValid] = useState(true);

    useEffect(() => {

        if (validated && props.formData.commercialInsurancePhone && props.formData.commercialInsurancePhone.length === 10)
            setPhoneValid(true);
        else if (validated)
            setPhoneValid(false);

    }, [props.formData.commercialInsurancePhone]);

    const twoWayBind = (event, key) => {

        event.preventDefault();
        event.stopPropagation();

        const data = { ...props.formData }

        switch (key) {

            case "currentFloorPlanCompaniesUsed":
                if (!currentFloorPlanCompaniesUsed)
                    return;
                data.currentFloorPlanCompaniesUsed.push(currentFloorPlanCompaniesUsed);
                props.twoWayBind('currentFloorPlanCompaniesUsed', data.currentFloorPlanCompaniesUsed);
                setCurrentFloorPlanCompaniesUsed('');
                break;
            case "currentRetailFinanceUsed":
                if (!currentRetailFinanceUsed)
                    return;
                data.currentRetailFinanceUsed.push(currentRetailFinanceUsed);
                props.twoWayBind('currentRetailFinanceUsed', data.currentRetailFinanceUsed);
                setCurrentRetailFinanceUsed('');
                break;
            case "productCompaniesUsed":
                if (!productCompaniesUsed)
                    return;
                data.productCompaniesUsed.push(productCompaniesUsed);
                props.twoWayBind('productCompaniesUsed', data.productCompaniesUsed);
                setProductCompaniesUsed('');
                break;
            default:
                break;

        }

    }

    const deleteBusinessRelationships = (key, value) => {

        const data = { ...props.formData }

        switch (key) {

            case "currentFloorPlanCompaniesUsed":
                props.twoWayBind('currentFloorPlanCompaniesUsed', data.currentFloorPlanCompaniesUsed.filter(item => item != value));
                break;
            case "currentRetailFinanceUsed":
                props.twoWayBind('currentRetailFinanceUsed', data.currentRetailFinanceUsed.filter(item => item != value));
                break;
            case "productCompaniesUsed":
                props.twoWayBind('productCompaniesUsed', data.productCompaniesUsed.filter(item => item != value));
                break;
            default:
                break;

        }

    }

    const submit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        setValidated(true);

        const form = event.currentTarget;

        let isCustomFieldsValid = true;

        if (props.formData.commercialInsurancePhone && props.formData.commercialInsurancePhone.length === 10)
            setPhoneValid(true);
        else {
            setPhoneValid(false);
            isCustomFieldsValid = false;
        }

        if (form.checkValidity() !== false && isCustomFieldsValid) {

            props.submitForm(event);

        }

    }

    const data = [];

    data.push(

        ...(props.formData.currentFloorPlanCompaniesUsed.map((item, index) => {
            return (<tr key={'currentFloorPlanCompaniesUsed' + index}>
                <td className="pl-2 align-middle">{item}</td>
                <td className="pl-2 align-middle">Floor Plan</td>
                <td><Image src={deleteIcon} className='icon-color cursor-pointer' onClick={() => deleteBusinessRelationships('currentFloorPlanCompaniesUsed', item)} /></td>
            </tr>)
        }))

    );

    data.push(

        ...(props.formData.currentRetailFinanceUsed.map((item, index) => {
            return (<tr key={'currentRetailFinanceUsed' + index}>
                <td className="pl-2 align-middle">{item}</td>
                <td className="pl-2 align-middle">Retail Finance</td>
                <td><Image src={deleteIcon} className='icon-color cursor-pointer' onClick={() => deleteBusinessRelationships('currentRetailFinanceUsed', item)} /></td>
            </tr>)
        }))

    );

    data.push(

        ...(props.formData.productCompaniesUsed.map((item, index) => {
            return (<tr key={'productCompaniesUsed' + index}>
                <td className="pl-2 align-middle">{item}</td>
                <td className="pl-2 align-middle">Other</td>
                <td><Image src={deleteIcon} className='icon-color cursor-pointer' onClick={() => deleteBusinessRelationships('productCompaniesUsed', item)} /></td>
            </tr>)
        }))

    );

    return (
        <React.Fragment>
            {/* <p className="content-text-14px content-text-color mb-4">We need this information to save your progress so that you can come back any time to finish your application.</p> */}
            <Form noValidate
                validated={validated}
                onSubmit={(event) => submit(event)}
                className="text-left">
                <div className='onboarding-form-box-modal'>
                    <h1 className="mb-4">Dealership Info</h1>
                    <p className='secondary-text-color mb-4'>Step 3/3 : Business Relationships</p>
                    <Form.Row className='two-fields-row mx-0'>
                        <Form.Group controlId="formBasicFN">
                            <TextBox
                                required
                                label="Commercial Insurance Provider"
                                name="Commercial Insurance Provider"
                                value={props.formData.commercialInsuranceName}
                                objectKey="commercialInsuranceName"
                                placeholder="Commercial Insurance Provider"
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color minHeightMobile-48px">Commercial Insurance Provider</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="insuranceProvider"
                                placeholder="Sample"
                                value={props.formData.commercialInsuranceName}
                                className="content-text-13px"
                                onChange={(event) => props.twoWayBind('commercialInsuranceName', event.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter Commercial Insurance Provider.
                            </Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group controlId="formBasicLN">
                            <Email
                                required
                                label="Commercial Insurance Contact Email"
                                name="Commercial Insurance Contact Email"
                                objectKey="commercialInsuranceEmail"
                                placeholder="Commercial Insurance Contact Email"
                                value={props.formData.commercialInsuranceEmail}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color">Commercial Insurance Contact Email</Form.Label>
                            <Form.Control
                                required
                                type="email"
                                name="insuranceContactEmail"
                                value={props.formData.commercialInsuranceEmail}
                                className="content-text-13px"
                                placeholder="Email Address"
                                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                                onChange={(event) => props.twoWayBind('commercialInsuranceEmail', event.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please enter valid email.
                            </Form.Control.Feedback> */}
                        </Form.Group>
                        <Form.Group controlId="formBasicDN">
                            <Phone
                                validated={validated}
                                required
                                label="Commercial Insurance Contact Phone"
                                name="Commercial Insurance Contact Phone"
                                objectKey="commercialInsurancePhone"
                                placeholder="(000) 000-0000"
                                value={props.formData.commercialInsurancePhone}
                                onChange={(key, value) => props.twoWayBind(key, value)}
                            />
                            {/* <Form.Label className="label-color">Commercial Insurance Contact Phone #</Form.Label>
                            <NumberFormat
                                className='content-text-13px form-control'
                                name="insuranceContactPhone"
                                format='(###) ###-####'
                                placeholder="(000) 000-0000"
                                value={props.formData.commercialInsurancePhone}
                                onValueChange={(values) => props.twoWayBind('commercialInsurancePhone', values.value)}
                                style={{ borderColor: (!phoneValid ? '#dc3545' : null) }}
                            /> */}
                            {/* <Form.Control
                        required
                        type="phone"
                        name="insuranceContactPhone"
                        value={props.formData.commercialInsurancePhone}
                        className="content-text-13px"
                        placeholder="(000) 000-0000"
                        onChange={(event) => props.twoWayBind('commercialInsurancePhone', event.target.value)}
                    /> 
                        <Form.Control.Feedback type="invalid">
                            Please enter valid phone number.
                        </Form.Control.Feedback> */}
                            {/* {!phoneValid ? <span style={{ fontSize: '80%', color: '#dc3545' }}>Please enter valid Commercial Insurance Contact Phone.</span> : null} */}
                        </Form.Group>
                    </Form.Row>
                    <Form.Row className='mx-0 input-group-btn-styles'>
                        <Form.Group as={Col} md={12} className='p-0' controlId="formBasicDN">
                            {/* <Form.Label className="label-color minHeightMobile-48px">Current Floorplan Companies Used</Form.Label>
                            <InputGroup>
                                <FormControl
                                    placeholder="Sample"
                                    aria-label="Sample"
                                    className="content-text-13px"
                                    style={{ borderRight: '0px' }}
                                    aria-describedby="basic-addon2"
                                    type="text"
                                    value={currentFloorPlanCompaniesUsed}
                                    onChange={(event) => setCurrentFloorPlanCompaniesUsed(event.target.value)}
                                />
                                <Button onClick={(event) => twoWayBind(event, 'currentFloorPlanCompaniesUsed')} type="button" variant="outline-secondary" style={{ border: '0px', backgroundColor: '#F2F2F2' }} className="content-sm-text blue-link-text letterspacing-1px" id="button-addon2">
                                    <Plus size={14} />  Add
                                </Button>
                            </InputGroup> */}
                            <TextBox
                                label='Current Floorplan Companies Used'
                                placeholder="Sample"
                                style={{ borderRight: '0px' }}
                                value={currentFloorPlanCompaniesUsed}
                                onChange={(key, value) => setCurrentFloorPlanCompaniesUsed(value)}
                            />
                            <Button onClick={(event) => twoWayBind(event, 'currentFloorPlanCompaniesUsed')} type="button" id="button-addon2">
                                <span className='mr-1'>Add</span><Image src={addIcon} />
                            </Button>
                            {/* <Form.Control.Feedback type="invalid">
                                Please enter floorplan companies used.
                            </Form.Control.Feedback> */}
                        </Form.Group>
                    </Form.Row>
                    <Form.Row className='mx-0 two-fields-row'>
                        <Form.Group controlId="formBasicDN" className='mb-0 input-group-btn-styles'>
                            {/* <Form.Label className="label-color minHeightMobile-48px">Current Retail Finance Sources Used</Form.Label>
                            <InputGroup>
                                <FormControl
                                    placeholder="Sample"
                                    aria-label="Sample"
                                    className="content-text-13px"
                                    style={{ borderRight: '0px' }}
                                    aria-describedby="basic-addon2"
                                    type="text"
                                    value={currentRetailFinanceUsed}
                                    onChange={(event) => setCurrentRetailFinanceUsed(event.target.value)}
                                />
                                <Button onClick={(event) => twoWayBind(event, 'currentRetailFinanceUsed')} type="button" variant="outline-secondary" style={{ border: '0px', backgroundColor: '#F2F2F2' }} className="content-sm-text blue-link-text letterspacing-1px" id="button-addon2">
                                    <Plus size={14} />  Add
                                </Button>
                            </InputGroup>
                            <Form.Control.Feedback type="invalid">
                                Please enter Retail Finance Sources Used.
                            </Form.Control.Feedback> */}
                            <TextBox
                                placeholder="Sample"
                                label="Current Retail Finance Sources Used"
                                type="text"
                                value={currentRetailFinanceUsed}
                                onChange={(key, value) => setCurrentRetailFinanceUsed(value)}
                            />
                            <Button onClick={(event) => twoWayBind(event, 'currentRetailFinanceUsed')} type="button" id="button-addon2">
                                <span className='mr-1'>Add</span><Image src={addIcon} />
                            </Button>
                        </Form.Group>
                        <Form.Group controlId="formBasicDN" className='mb-0 input-group-btn-styles'>
                            {/* <Form.Label className="label-color">Add Product Companies Used (GAP and Warranty)</Form.Label> */}
                            {/* <InputGroup>
                                <FormControl
                                    placeholder="Sample"
                                    aria-label="Sample"
                                    className="content-text-13px"
                                    style={{ borderRight: '0px' }}
                                    aria-describedby="basic-addon2"
                                    type="text"
                                    value={productCompaniesUsed}
                                    onChange={(event) => setProductCompaniesUsed(event.target.value)}
                                />
                                <Button onClick={(event) => twoWayBind(event, 'productCompaniesUsed')} type="button" variant="outline-secondary" style={{ border: '0px', backgroundColor: '#F2F2F2' }} className="content-sm-text blue-link-text letterspacing-1px" id="button-addon2">
                                    <Plus size={14} />  Add
                                </Button>
                            </InputGroup>
                            <Form.Control.Feedback type="invalid">
                                Please enter .
                            </Form.Control.Feedback> */}
                            <TextBox
                                placeholder="Sample"
                                label="Add Product Companies Used (GAP and Warranty)"
                                value={productCompaniesUsed}
                                onChange={(key, value) => setProductCompaniesUsed(value)}
                            />
                            <Button onClick={(event) => twoWayBind(event, 'productCompaniesUsed')} type="button" id="button-addon2">
                                <span className='mr-1'>Add</span><Image src={addIcon} />
                            </Button>
                        </Form.Group>
                    </Form.Row>
                </div>
                {data.length > 0 ?
                    <Row>
                        <Col className="mb-4 left-align-table content-sm-text">
                            <Table responsive className='default-table'>
                                <thead className="table-header-bg-color">
                                    <th className="pl-2">Name of the Company</th>
                                    <th>Type of Service</th>
                                    <th>Actions</th>
                                </thead>
                                <tbody>
                                    {data}
                                </tbody>
                            </Table>
                        </Col>
                    </Row> : null}
                <div>
                    <Button type="button" onClick={(event) => props.submitForm(event, true)} variant="outline-secondary" className="default-btn">Previous</Button>
                    <Button className="default-btn ml-3" type="submit" variant="primary">Next</Button>
                </div>
            </Form>
        </React.Fragment>
    );

}

export default DealershipInfoS3;